function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import PropTypes from 'prop-types';
import React from 'react';
import Box from './Box';
import Flex from './Flex';
const labelStyles = {
  fontWeight: 'bold',
  color: 'darkBlue'
};
const cellStyles = {
  py: 2,
  px: 3,
  borderBottom: 'default'
};
const columnHeaderStyles = {
  fontSize: 1,
  textTransform: 'uppercase',
  ...cellStyles,
  ...labelStyles
};
const normalizeLabel = label => typeof label === 'string' && label.charAt(0) === '_' ? '' : label;
const ListGrid = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(Box, _extends({
  ref: ref,
  __css: {
    bg: 'white',
    border: 'default',
    borderRadius: 'corner',
    p: 3,
    textAlign: 'left'
  }
}, props), props.stacked ? /*#__PURE__*/React.createElement(Stacked, {
  items: props.items
}) : /*#__PURE__*/React.createElement(Grid, {
  items: props.items
})));
const Stacked = _ref => {
  let {
    items
  } = _ref;
  const rows = React.useMemo(() => {
    if (!Array.isArray(items)) return [];
    return items.reduce((rows, item) => {
      rows.push(Object.keys(item).map(label => ({
        label: normalizeLabel("".concat(label, ":")),
        value: item[label]
      })));
      return rows;
    }, []);
  }, [items]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, rows.map((row, i) => /*#__PURE__*/React.createElement(Box, {
    key: i,
    __css: {
      ...cellStyles,
      borderBottom: i === rows.length - 1 ? 'none' : 'default'
    }
  }, row.map((_ref2, j) => {
    let {
      label,
      value
    } = _ref2;
    return /*#__PURE__*/React.createElement(Flex, {
      key: j,
      alignItems: "center",
      justifyContent: "space-between"
    }, /*#__PURE__*/React.createElement(Box, {
      __css: {
        ...labelStyles
      }
    }, label), /*#__PURE__*/React.createElement(Box, {
      __css: {
        ml: 2
      }
    }, value));
  }))));
};
const Grid = _ref3 => {
  let {
    items
  } = _ref3;
  const rows = React.useMemo(() => {
    if (!Array.isArray(items)) return [];
    return items.reduce((rows, item) => {
      if (!rows.length) rows.push(Object.keys(item).map(normalizeLabel));
      rows.push(Object.values(item));
      return rows;
    }, []);
  }, [items]);
  return /*#__PURE__*/React.createElement(Box, {
    as: "table",
    sx: {
      borderCollapse: 'collapse',
      borderSpacing: 0,
      width: '100%'
    }
  }, /*#__PURE__*/React.createElement(Box, {
    as: "tbody"
  }, rows.map((row, i) => /*#__PURE__*/React.createElement(Box, {
    key: i,
    as: "tr"
  }, row.map((cell, j) => /*#__PURE__*/React.createElement(Box, {
    key: j,
    as: i === 0 ? 'th' : 'td',
    sx: i === 0 ? columnHeaderStyles : {
      ...cellStyles,
      borderBottom: i === rows.length - 1 ? 'none' : 'default'
    }
  }, cell))))));

  // return <Flex justifyContent="space-between">
  //   {columns.map((column, i) => <Box key={i}>
  //     {column.map((cell, j) => <Box key={j} __css={j === 0 ? columnHeaderStyles : cellStyles}>{cell}</Box>)}
  //   </Box>)}
  // </Flex>;
};

ListGrid.propTypes = {
  items: PropTypes.array.isRequired,
  stacked: PropTypes.bool
};
ListGrid.defaultProps = {
  stacked: false
};
ListGrid.displayName = 'ListGrid';
export default ListGrid;